var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"css-tr"},[_vm._m(0),_c('div',{staticClass:"css-td pulldownChangeSelectorStore-group"},[_c('city-town-store')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-bold align right w-f6 spacing top"},[_c('b',{staticClass:"notice"},[_vm._v("*")]),_vm._v(" 取貨門市 ")])
}]

export { render, staticRenderFns }